import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import AmplifySpinnerOverlay from "@/v2/user-interface/_common/loaders/AmplifySpinnerOverlay";
import { getIsActionLoading, getIsAnyActionLoading } from "@/v2/application/_common/loader/loader.selectors";
import { useSelector } from "react-redux";
export const ActivateForAnyLoad = 'asdfowieunwevpoiq213087432';
export default function FullPageLoader({ loadingActions, children, }) {
    const isActionLoading = (loadingActions === ActivateForAnyLoad)
        ? useSelector(getIsAnyActionLoading)
        : useSelector(getIsActionLoading(loadingActions));
    return (_jsxs(_Fragment, { children: [isActionLoading && _jsx(AmplifySpinnerOverlay, {}), children] }));
}
